
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class PayrollPeriodDialog extends Serenity.EntityDialog<PayrollPeriodRow, any> {
        protected getFormKey() { return PayrollPeriodForm.formKey; }
        protected getIdProperty() { return PayrollPeriodRow.idProperty; }
        protected getLocalTextPrefix() { return PayrollPeriodRow.localTextPrefix; }
        protected getNameProperty() { return PayrollPeriodRow.nameProperty; }
        protected getService() { return PayrollPeriodService.baseUrl; }
        protected getDeletePermission() { return PayrollPeriodRow.deletePermission; }
        protected getInsertPermission() { return PayrollPeriodRow.insertPermission; }
        protected getUpdatePermission() { return PayrollPeriodRow.updatePermission; }

        protected form = new PayrollPeriodForm(this.idPrefix);

    }
}